import styled from 'styled-components';

export const TextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  max-width: 100%;
`;
